import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views

// Therapists
const TherapistContact = () => import('@/views/therapist/Contact')
const TherapistSchedule = () => import('@/views/therapist/Schedule')
// const DataAnalyzer = () => import('@/views/DataAnalyzer')
const TherapistLoading = () => import('@/views/TherapistLoading')
const MassRetargetingHelper = () => import('@/views/MassRetargeting')
const OpsDashboard = () => import('@/views/OpsDashboard')
const Offers = () => import('@/views/offer/Dashboard')
const TherapistPortalV2 = () => import('@/views/TherapistPortalV2')
const Reports = () => import('@/views/Reports')
const Zipcodes = () => import('@/views/Zipcodes')
const Contacts = () => import('@/views/Contacts/index')
const CaseMap = () => import('@/views/Contacts/case-map')
const HeatMap = () => import('@/views/Contacts/heat-map')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
	  path: '/',
      redirect: '/ops-dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'therapist-dashboard-v2',
          name: 'Therapist Portal',
          component: TherapistPortalV2,
        },
        {
          path: 'zipcodes',
          name: 'Zipcodes',
          component: Zipcodes
        },
        {
          path: 'massretargeting',
          name: 'Mass Retargeting Helper',
          component: MassRetargetingHelper
        },
        // {
        //   path: 'datadownload',
        //   name: 'Case Data',
        //   component: DataAnalyzer
        // },
        {
          path: 'therapist-loading',
          name: 'Therapist Loading',
          component: TherapistLoading
        },
        {
          path: 'ops-dashboard',
          name: 'Ops Dashboard',
          component: OpsDashboard
        },
        {
          path: 'offers',
          name: 'Offers',
          component: Offers
        },
        {
          path: 'reports',
          name: 'Reports',
          component: Reports
        },
        {
          path: 'contacts',
          name: 'Therapist Maps',
          component: Contacts,
          redirect: '/contacts/case-map',
          children: [
            {
              path: 'case-map',
              name: 'case-map',
              component: CaseMap
            },
            {
              path: 'heat-map',
              name: 'heat-map',
              component: HeatMap
            }
          ]
        },
        {
          path: 'profile',
          redirect: '/profile/contact',
          name: 'Profile',
          component: {
          render (c) { return c('router-view') }
          },
          children: [
          {
            path: 'contact',
            name: 'Contact Info',
            component: TherapistContact
          },
          {
            path: 'schedule',
            name: 'Schedule',
            component: TherapistSchedule
          }

          ]
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
          ]
        },
        ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
		  component: Page404,
		  meta: {requiresAuth:false}
        },
        {
          path: '500',
          name: 'Page500',
		  component: Page500,
		  meta: {requiresAuth:false}
        },
        {
          path: 'login',
          name: 'Login',
		  component: Login,
		  meta: {requiresAuth:false}
        },
        {
          path: 'register',
          name: 'Register',
		  component: Register,
		  meta: {requiresAuth:false}
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.token || null;
  const requiresAuth = to.meta.requiresAuth===false ? false : true;

  if (requiresAuth && !token) {
	const loginpath = to.fullPath
    next({ name: 'Login', query: { from: loginpath } })
  } else {
	  next()
  }
});

export default router
